// Brand artwork drawn inline so it is part of the app bundle: it renders even
// when /brand/*.svg can't be fetched (offline, flaky network, stale service worker).
// Keep in sync with public/brand/legal-beagle.svg and public/brand/hk-mark.svg.

export function LegalBeagle({ title = "Leego Beego, the legal beagle", ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" role="img" aria-label={title} {...props}>
      <circle cx="50" cy="50" r="48" fill="#F8F5EE" stroke="#C5A15A" strokeWidth="2" />
      <path d="M18 94q3-28 32-30 29 2 32 30" fill="#14243B" />
      <path d="m39 69 11 25 11-25" fill="white" />
      <path d="m50 75-5 8 5 13 5-13Z" fill="#C5A15A" />
      <ellipse cx="50" cy="42" rx="25" ry="31" fill="#BE8549" />
      <path d="M31 16C7 13 12 71 25 64q8-13 6-48M69 16c24-3 19 55 6 48-8-13-6-32-6-48" fill="#784929" />
      <path d="M48 13h4l3 30q19 26-5 29-24-3-5-29Z" fill="#FFF9ED" />
      <ellipse cx="39" cy="38" rx="4" ry="5" fill="#14243B" />
      <ellipse cx="61" cy="38" rx="4" ry="5" fill="#14243B" />
      <circle cx="40" cy="36" r="1.4" fill="white" />
      <circle cx="62" cy="36" r="1.4" fill="white" />
      <path d="M43 52q7-5 14 0-1 8-7 8t-7-8" fill="#14243B" />
      <path d="M50 59v5m-8-1q8 8 16 0" fill="none" stroke="#14243B" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function HkMark({ title, ...props }) {
  const label = title ? { role: "img", "aria-label": title } : { "aria-hidden": true };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 230" fill="none" {...label} {...props}>
      <g stroke="#C5A15A" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
        <path d="M120 12v28M120 65v143M28 49h77M135 49h77" />
        <path d="M120 65l-14-13c-13-13 5-25 14-13 9-12 27 0 14 13Z" />
        <path d="M28 49v18L4 113h48L28 67M188 113l24-46 24 46ZM212 49v18M4 113c2 27 46 27 48 0M188 113c2 27 46 27 48 0M67 203l40 11c4 15 22 15 26 0l40-11" />
      </g>
      <g fill="#C5A15A" fontFamily="Georgia,serif" fontSize="107">
        <text x="67" y="192" textLength="43" lengthAdjust="spacingAndGlyphs">H</text>
        <text x="132" y="192" textLength="43" lengthAdjust="spacingAndGlyphs">K</text>
      </g>
    </svg>
  );
}
